// extracted by mini-css-extract-plugin
export default {"cls1":"Y4iPCUcuz5eWw3P7d7D9","cls2":"he7_NGRv5PHMS6SXra0s Y4iPCUcuz5eWw3P7d7D9"};